import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { DateTime } from 'luxon';
import { GenericDatePicker } from '../../components';
import { InputModel } from '../../models';
import { InputWithoutSource } from '../../componentTypes';

const DueDateInput: InputWithoutSource = ({ input }) => (
    <GenericDatePicker
        label={input.name}
        input={input}
        normalize={value => {
            if (!(value instanceof Date)) {
                return value;
            }

            return DateTime.fromJSDate(value).startOf('day').toJSDate();
        }}
    />
);

DueDateInput.meta = {
    inputType: InputModel.name
};

export default observer(DueDateInput);
